<template>
  <a-form :form="form" id="form">
    <a-row :gutter="16">
      <a-col :xs="{span: 24}" :lg="{span:12}">
        <a-form-item label="Description of Document Functions">
          <a-input v-model="fungsi" />
        </a-form-item>
        <a-form-item label="Select Document">
          <a-upload
            accept=".pdf"
            :showUploadList="false"
            :beforeUpload="beforeUpload"
            v-decorator="['upload', { valuePropName: 'push'}]"
          >
            <a-button>
              <a-icon type="upload" />&nbsp;Select File
            </a-button>
          </a-upload>
        </a-form-item>
      </a-col>
    </a-row>
    <a-row :gutter="16">
      <a-col :xs="{span: 24}" :lg="{span:12}">
        <a-card :loading="uploading" class="margin-top margin-bottom" title="Supporting Documents">
          <a-list
            itemLayout="horizontal"
            :loading="uploading"
            :dataSource="existing"
            v-if="mode === 'Edit' && existing.length > 0"
          >
            <a-list-item slot="renderItem" slot-scope="item">
              <a-list-item-meta>
                <div slot="title" class="m-display-flex space-between align-middle">
                  <h3>{{item.fungsi}}</h3>
                  <a-button @click="handleRemoveExisting(item.id_dokumen)" type="link">Remove</a-button>
                </div>
                <template slot="description">
                  <span :class="getScreen ? 'm-list-dots' : ''">{{item.nama_dokumen}}</span>
                </template>
                <!-- <img class="m-image-icon" slot="avatar" src="@/assets/icon/pdf_ico.png" /> -->
              </a-list-item-meta>
            </a-list-item>
          </a-list>
          <a-list
            itemLayout="horizontal"
            :loading="uploading"
            :dataSource="push"
            v-if="push.length > 0"
          >
            <a-list-item slot="renderItem" slot-scope="item">
              <a-list-item-meta>
                <div slot="title" class="m-display-flex space-between align-middle">
                  <h3>{{item.fungsi_document}}</h3>
                  <a-button @click="handleRemove(item.file.uid)" type="link">Remove</a-button>
                </div>
                <template slot="description">
                  <span :class="getScreen ? 'm-list-dots' : ''">{{item.fileName}}</span>
                </template>
                <!-- <img class="m-image-icon" slot="avatar" src="@/assets/icon/pdf_ico.png" /> -->
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </a-card>

        <a-form-item label="Note">
          <a-textarea v-model="keterangan" placeholder="Write the note here ..." autoSize />
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "DokumenPendukung",
  props: {
    data: {},
    mode: String
  },
  data() {
    return {
      file: "",
      uploading: false,
      push: [],
      existing: [],
      fungsi: "",
      keterangan: ""
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    if (this.mode === "Edit") {
      this.existing = this.data.dokumen;
      this.keterangan = this.data.keterangan;
    }
  },
  computed: {
    ...mapGetters(["getScreen"])
  },
  methods: {
    handleRemoveExisting(id) {
      const index = this.existing.indexOf(id);
      const newPush = this.existing.filter(item => item.id_dokumen !== id);
      this.existing = newPush;
    },
    handleRemove(file) {
      const index = this.push.indexOf(file);
      const newPush = this.push.filter(item => item.file.uid !== file);
      this.push = newPush;
    },
    beforeUpload(file) {
      // Event.$emit("newDocument", { file: file, fungsi: this.fungsi });
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 2) {
        this.displayMessage("large-file-2mb");
      } else if (this.fungsi === "") {
        this.displayMessage("error-emptyDocFunction");
      } else {
        this.push = [
          ...this.push,
          {
            file,
            fungsi_document: this.fungsi,
            fileName: file.name
          }
        ];

        this.fungsi = "";
        return false;
      }
    },
    handleRef() {
      Event.$emit("purchasingData", {
        dokumen: this.push,
        existing: this.existing,
        keterangan: this.keterangan
      });
    }
  }
};
</script>

<style>
</style>